<h2 mat-dialog-title>{{ data.title | transloco }}</h2>
<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="search-row">
        <mat-form-field class="full-width">
            <mat-label>{{ (data.searchLabel || "search") | transloco }}</mat-label>
            <input matInput
                   [ngModel]="searchQuery()"
                   (ngModelChange)="onSearch($event)"
                   autocomplete="off">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-slide-toggle
                [checked]="showSelectedOnly()"
                (change)="toggleShowSelected()">
            {{ "show_selected_only" | transloco }}
        </mat-slide-toggle>
    </div>

    @if (isLoading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <table mat-table [dataSource]="filteredItems()">
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                        [checked]="isSelected(row)"
                        (change)="toggleRow(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        @for (col of data.columns; track col.key) {
            <ng-container [matColumnDef]="col.key">
                <th mat-header-cell *matHeaderCellDef>{{ col.label | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ col.valueFn ? col.valueFn(row) : $any(row)[col.key] }}</td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>

    @if (!isLoading() && filteredItems().length === 0) {
        <div class="no-entries">{{ "no_entries" | transloco }}</div>
    }

    @if (!showSelectedOnly()) {
        <mat-paginator
                [length]="total()"
                [pageSize]="pageSize()"
                [pageIndex]="page()"
                [pageSizeOptions]="[10, 20, 50]"
                (page)="onPageChange($event)">
        </mat-paginator>
    }
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ "cancel" | transloco }}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{ "save" | transloco }}</button>
</mat-dialog-actions>
